import { t } from "@lingui/macro";

import { Avatar, Loader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { useFlags } from "../../../../utils/launchDarkly";
import { ImageObjectStateProps } from "../../types";

type EditPhotoProps = {
  hasProfileImage: boolean;
  publicId?: string;
  memberFirstName?: string | null;
  memberLastName?: string | null;
  isImageUploading: boolean;
  pickImage: () => void;
  setRemovedImage: (val: boolean) => void;
  setImageObject: (val: ImageObjectStateProps | null) => void;
};

export const EditPhoto = ({
  hasProfileImage,
  publicId,
  memberFirstName,
  memberLastName,
  isImageUploading,
  pickImage,
  setRemovedImage,
  setImageObject,
}: EditPhotoProps) => {
  const { memberImageUploadVisibility } = useFlags();

  return (
    memberImageUploadVisibility && (
      <Box flexDirection="row" alignItems="center" justifyContent="flex-start">
        {isImageUploading ? (
          <Box
            width={96}
            height={96}
            alignItems="center"
            justifyContent="center"
          >
            <Loader />
          </Box>
        ) : (
          <Pressable
            onPress={pickImage}
            testID="image-placeholder-selector-btn"
          >
            <Avatar
              firstName={memberFirstName}
              lastName={memberLastName}
              size="lg"
              profileImagePublicId={publicId}
              testID="profile-photo-avatar"
            />
          </Pressable>
        )}
        <HStack flexWrap="wrap" flex={1} ml={6} gap={2}>
          <Pressable
            justifyContent="center"
            backgroundColor="grayscale-100"
            px={3}
            py={2}
            mb={2}
            height={32}
            style={{ borderRadius: 8 }}
            onPress={pickImage}
          >
            <Text variant="mainTiny" color="grayscale-1000">
              {t`Upload New Image`}
            </Text>
          </Pressable>

          {hasProfileImage ? (
            <Pressable
              justifyContent="center"
              backgroundColor="grayscale-100"
              px={3}
              py={2}
              height={32}
              style={{ borderRadius: 8 }}
              onPress={() => {
                setImageObject(null);
                setRemovedImage(true);
              }}
            >
              <Text variant="mainTiny" color="grayscale-1000">
                {t`Remove Image`}
              </Text>
            </Pressable>
          ) : null}
        </HStack>
      </Box>
    )
  );
};
